module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921043834_T.d06730b1.jpg";